import React, { useState, useRef, useEffect } from 'react';
import FastTooltip from '../FastTooltip';

interface TruncatedTextProps {
  text: string;
  className?: string;
  maxLines?: number;
}

/**
 * Component for truncated text with tooltip.
 * Automatically shows a tooltip if the text exceeds the specified maxLines.
 */
const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  className = '',
  maxLines = 2,
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // Check if text is truncated after component mounts/updates
  useEffect(() => {
    if (textRef.current && text) {
      const element = textRef.current;
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * maxLines;
      setIsTruncated(element.scrollHeight > maxHeight);
    }
  }, [text, maxLines]);

  const textContent = (
    <div
      ref={textRef}
      className={`font-baijamjuree text-sm text-gray-900 break-words leading-tight ${className}`}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {text}
    </div>
  );

  return (
    <div className="min-w-0">
      {isTruncated ? (
        <FastTooltip tooltip={text} className="cursor-help">
          {textContent}
        </FastTooltip>
      ) : (
        textContent
      )}
    </div>
  );
};

export default TruncatedText;
